import { createAction } from 'redux-actions';
import { fetchJson } from '../../../../../../utils/fetch';

export const fetchFormAction = createAction('step2.FETCH_FORM');
export const fetchFormSuccessAction = createAction('step2.FETCH_FORM_SUCCESS');
export const updateDataAction = createAction('step2.UPDATE_FIELD');
export const toggleTaskAction = createAction('step2.TOGGLE_TASK');

export const fetchForm = caseId => (dispatch, getState) => {
  const state = getState();
  if (state.form.isFetching) {
    return Promise.resolve();
  }

  dispatch(fetchFormAction());

  if (caseId) {
    return fetchJson(`/pco-manager/cases-creation/${caseId}/step2.json`).then(
      response => {
        dispatch(fetchFormSuccessAction(response));
      }
    );
  } else {
    return dispatch(fetchFormSuccessAction({}));
  }
};

export const updateData = (siteId, task, propName, propValue) => (
  dispatch,
  getState
) => {
  dispatch(updateDataAction({ siteId, task, propName, propValue }));
};

export const toggleTask = (siteId, task) => (dispatch, getState) => {
  dispatch(toggleTaskAction({ siteId, task }));
};



// WEBPACK FOOTER //
// ./src/modules/saas/pco/cases-creation/step2/actions/form.js